import { render, staticRenderFns } from "./VulnerabilityItem.vue?vue&type=template&id=dbcd72fe&scoped=true"
import script from "./VulnerabilityItem.vue?vue&type=script&lang=js"
export * from "./VulnerabilityItem.vue?vue&type=script&lang=js"
import style0 from "./VulnerabilityItem.vue?vue&type=style&index=0&id=dbcd72fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcd72fe",
  null
  
)

export default component.exports